module.exports = __webpack_public_path__ + "img/xtpt_03.92e8a63e.png";